@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  .message {
    display: inline-flex;
    align-items: flex-start;
    gap: var(--semantic-spacing-content-s-gap-plain);
    border: none; /* reset browser default borders */
    font-family: var(--semantic-font-family-utility);
    font-size: var(--semantic-font-size-utility-s);
    font-style: normal;
    font-weight: var(--semantic-font-weight-utility-default);
    line-height: var(--semantic-line-height-utility-s);
    letter-spacing: var(--semantic-letter-spacing-utility-s);

    .icon {
      width: var(--semantic-size-content-s);
      height: var(--semantic-size-content-s);
      font-family: "Allianz Icons"; /* stylelint-disable -- Declaration of custom font. */
      font-size: var(--semantic-size-content-s);
      vertical-align: text-bottom;
    }

    /* TYPE */
    &.critical {
      color: var(--semantic-color-signal-attention-critical-resting);

      .icon:before {
        content: "\e914";
      }
    }

    &.warning {
      color: var(--semantic-color-signal-attention-warning-resting);

      .icon:before {
        content: "\e918";
      }
    }

    &.positive {
      color: var(--semantic-color-signal-attention-positive-resting);

      .icon:before {
        content: "\e912";
      }
    }

    &.info {
      color: var(--semantic-color-signal-attention-info-resting);

      .icon:before {
        content: "\e920";
      }
    }
  }
}
